// src/template-library/Footer/TemplateFooter1.jsx
import React from 'react';
import { Link, useNavigate } from 'react-router-dom'; // 👈 Added useNavigate
import styles from './TemplateFooter1.module.css';
import { FaPhone, FaEnvelope } from 'react-icons/fa';
import { useAuth } from '../../Common/Configurations/AuthContext';

const TemplateFooter1 = ({ 
  branding, 
  footerData, 
  headerMenu = [], 
  onNavigate, 
  mode,        // 👈 Added mode
  templateId   // 👈 Added templateId 
}) => {
  const { user } = useAuth();
  const navigate = useNavigate(); // 👈 Initialize navigate

  const companyName = branding?.companyName || user?.companyName || "Travel Agency";
  const brandName =
  branding?.brandName ||
  user?.brandName ||
  "Travel Agency";
  const phone =
  branding?.phones?.join(" | ") ||
  user?.companyPhone ||
  "+91 0000000000";
  const email =
  branding?.email ||
  user?.companyEmail ||
  "contact@travel.com";
  const aboutText = footerData?.aboutText || "Discover the world with us.";

  const handleNavClick = (e, item) => {
    // Extract view name (e.g., "/destinations" -> "destinations")
    const viewName = item.path === "/" ? "home" : item.path.replace('/', '');

    // SCENARIO 1: BUILDER MODE
    if (mode === "builder") {
      e.preventDefault(); 
      onNavigate({ name: viewName, params: null });
    } 
    // SCENARIO 2: PREVIEW MODE
    else if (mode === "preview") {
      e.preventDefault();
      // Keep the templateId in the URL so it doesn't break
      navigate(`/template-preview/${templateId}/${viewName}`);
    }
    // SCENARIO 3: LIVE MODE
    // Standard <Link> behavior (no preventDefault needed)
  };

  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.grid}>
          {/* Column 1: About */}
          <div className={styles.column}>
           <h3 className={styles.title}>{brandName}</h3>
            <p className={styles.text}>{aboutText}</p>
          </div>

          {/* Column 2: Quick Links */}
          <div className={styles.column}>
            <h4 className={styles.subTitle}>Quick Links</h4>
            <ul className={styles.linkList}>
              {headerMenu.map(item => (
                <li key={item.id}>
                  <Link to={item.path} onClick={(e) => handleNavClick(e, item)}>
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3: Contact */}
          <div className={styles.column}>
            <h4 className={styles.subTitle}>Contact Us</h4>
            <div className={styles.contactItem}><FaPhone /> <span>{phone}</span></div>
            <div className={styles.contactItem}><FaEnvelope /> <span>{email}</span></div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default TemplateFooter1;